export const coupons = [
    {
      title: "2023 로스트아크 WINTER SHOWCASE",
      code: "23윈터쇼케이스감사선물",
      validUntil: "2024.03.27(수)점검 전 까지",
    },
    {
        title: "카멘 The FIRST 이벤트 승리",
        code: "위대한도전과승리",
        validUntil: "2024.03.27(수)점검 전 까지"
    },
    {
        title: "로스트아크 5주년",
        code: "5주년감사선물",
        validUntil: "2024.03.27(수)점검 전 까지"
    }
  ];